import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Popover, PopoverContent, PopoverPortal, PopoverTrigger } from '@radix-ui/react-popover';
import { InfoIcon } from '../../icons';
import { Text } from '../typography';
import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
// Replicated from codegen types
export var Role;
(function (Role) {
    Role["SUPER_ADMIN"] = "Super Admin";
    Role["ADMIN"] = "Admin";
    Role["GROOMER"] = "Groomer";
    Role["RECEPTIONIST"] = "Receptionist";
})(Role || (Role = {}));
const roleDescriptions = {
    [Role.SUPER_ADMIN]: {
        role: Role.SUPER_ADMIN,
        name: 'Super Admin',
        description: 'Highest level access with full system control.',
        permissions: [
            'All Admin permissions',
            'Manage subscription and billing',
            'Access to system-level settings',
            'Full control over all team members',
        ],
    },
    [Role.ADMIN]: {
        role: Role.ADMIN,
        name: 'Admin',
        description: 'Full administrative access to all features and settings.',
        permissions: [
            'Manage all appointments and schedules',
            'Invite and manage team members',
            'Create, edit, and delete clients and pets',
            'Manage services and pricing',
            'Configure locations and business settings',
            'View and manage billing',
            'Full access to all reports and analytics',
        ],
    },
    [Role.GROOMER]: {
        role: Role.GROOMER,
        name: 'Groomer',
        description: 'Access to manage appointments and client services.',
        permissions: [
            'View and manage appointments',
            'Create and update client information',
            'View and update pet information',
            'Access their own schedule',
            'Update their profile',
            'View services and pricing',
        ],
    },
    [Role.RECEPTIONIST]: {
        role: Role.RECEPTIONIST,
        name: 'Receptionist',
        description: 'Front desk access for managing bookings and client check-ins.',
        permissions: [
            'View and create appointments',
            'Manage client information',
            'Check-in clients',
            'View schedules',
            'Update their profile',
        ],
    },
};
export function RoleHelpPopover() {
    const [isOpen, setIsOpen] = useState(false);
    return (_jsxs(Popover, { open: isOpen, onOpenChange: setIsOpen, children: [_jsx(PopoverTrigger, { asChild: true, children: _jsx("button", { type: "button", className: "inline-flex items-center justify-center text-fg-subtle hover:text-fg-muted focus:outline-none", "aria-label": "Role information", children: _jsx(InfoIcon, { className: "size-4" }) }) }), _jsx(AnimatePresence, { children: isOpen && (_jsx(PopoverPortal, { children: _jsx(PopoverContent, { side: "top", align: "start", sideOffset: 8, collisionPadding: 16, asChild: true, children: _jsxs(motion.div, { initial: { opacity: 0, scale: 0.95 }, animate: { opacity: 1, scale: 1 }, exit: { opacity: 0, scale: 0.95 }, transition: { duration: 0.15 }, className: "z-[60] w-[380px] max-w-[calc(100vw-2rem)] rounded-card-sm bg-surface border border-border shadow-popover flex flex-col", children: [_jsx("div", { className: "flex items-center justify-between border-b border-border p-stack-roomy", children: _jsx(Text, { as: "h1", type: "h3", className: "font-semibold text-fg", children: "Role Permissions" }) }), _jsx("div", { className: "flex flex-col gap-stack-roomy max-h-80 overflow-y-auto p-stack-roomy", children: Object.values(roleDescriptions).map((role) => (_jsxs("div", { className: "flex flex-col gap-stack-tight", children: [_jsx(Text, { type: "s", className: "font-semibold text-fg", children: role.name }), _jsx(Text, { type: "xs", children: role.description }), _jsx("ul", { className: "flex flex-col gap-stack-dense pl-0", children: role.permissions.map((permission, index) => (_jsxs("li", { className: "flex items-center gap-stack-tight", children: [_jsx("span", { className: "text-fg-link flex-shrink-0", children: "\u2022" }), _jsx(Text, { type: "xs", className: "text-fg-muted", children: permission })] }, index))) })] }, role.name))) })] }) }) })) })] }));
}
